// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 5-day forecast cards with temperature chart */

.forecast__list {
  padding: 0;
  width: 100%;
  margin: 0;
  display: flex;
  justify-content: space-between;
}

.forecast-icon {
  max-width: 50px;
}

.forecast__item {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

.forecast__item > * {
  margin: 0;
}

.forecast__temp-max {
  font-size: 2rem;
  font-weight: 500;
}

.forecast__day-name {
  /* eslint-disable-next-line css/no-invalid-properties */
  font-family: var(--font-jakarta);
  font-weight: 600;
  justify-content: center;
}

.forecast__chart {
  width: 100%;
  height: 80px; /* Adjust height to fit between your two forecast lists */
  display: block;
  margin: 0.5rem 0;
  overflow: visible; /* Ensures strokes aren't clipped at the top/bottom */
}

/* Base properties for all paths */
.forecast__chart path {
  vector-effect: non-scaling-stroke;
  /* Forces the browser to use high-quality geometric anti-aliasing */
  shape-rendering: geometricPrecision;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* The 'Ribbon' Fill - The glassmorphism core */
.forecast__fill {
  /* Subtle white tint that interacts with your background */
  fill: rgba(255, 255, 255, 0.08);
  stroke: none;
  pointer-events: none;
}

.forecast__high-path {
  stroke: white;
  stroke-width: 2.5; /* Visual thickness */
  /* A slight blur on the stroke makes the curve look even smoother */
  filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.5));
  transition: stroke-width 0.2s ease;
  cursor: help;
  pointer-events: stroke;
}

/* Low Temperature Line - Faded for hierarchy */
.forecast__low-path {
  stroke: rgba(255, 255, 255, 0.4);
  stroke-width: 2;
  fill: none;
  transition: stroke-width 0.2s ease;
  cursor: help;
  pointer-events: stroke;
}

/* Visual feedback when hovering */
.forecast__high-path:hover {
  stroke-width: 4; /* Gets thicker to show it's active */
}

.forecast__low-path:hover {
  stroke-width: 4;
  stroke: rgba(255, 255, 255, 0.8);
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/nextdaysForecast.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;EACvD,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,yDAAyD;EACvE,cAAc;EACd,gBAAgB;EAChB,iBAAiB,EAAE,qDAAqD;AAC1E;;AAEA,kCAAkC;AAClC;EACE,iCAAiC;EACjC,mEAAmE;EACnE,mCAAmC;EACnC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,0DAA0D;EAC1D,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB,EAAE,qBAAqB;EACxC,mEAAmE;EACnE,qDAAqD;EACrD,kCAAkC;EAClC,YAAY;EACZ,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,gCAAgC;EAChC,eAAe;EACf,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,eAAe,EAAE,qCAAqC;AACxD;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC","sourcesContent":["/* 5-day forecast cards with temperature chart */\n\n.forecast__list {\n  padding: 0;\n  width: 100%;\n  margin: 0;\n  display: flex;\n  justify-content: space-between;\n}\n\n.forecast-icon {\n  max-width: 50px;\n}\n\n.forecast__item {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.forecast__item > * {\n  margin: 0;\n}\n\n.forecast__temp-max {\n  font-size: 2rem;\n  font-weight: 500;\n}\n\n.forecast__day-name {\n  /* eslint-disable-next-line css/no-invalid-properties */\n  font-family: var(--font-jakarta);\n  font-weight: 600;\n  justify-content: center;\n}\n\n.forecast__chart {\n  width: 100%;\n  height: 80px; /* Adjust height to fit between your two forecast lists */\n  display: block;\n  margin: 0.5rem 0;\n  overflow: visible; /* Ensures strokes aren't clipped at the top/bottom */\n}\n\n/* Base properties for all paths */\n.forecast__chart path {\n  vector-effect: non-scaling-stroke;\n  /* Forces the browser to use high-quality geometric anti-aliasing */\n  shape-rendering: geometricPrecision;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* The 'Ribbon' Fill - The glassmorphism core */\n.forecast__fill {\n  /* Subtle white tint that interacts with your background */\n  fill: rgba(255, 255, 255, 0.08);\n  stroke: none;\n  pointer-events: none;\n}\n\n.forecast__high-path {\n  stroke: white;\n  stroke-width: 2.5; /* Visual thickness */\n  /* A slight blur on the stroke makes the curve look even smoother */\n  filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.5));\n  transition: stroke-width 0.2s ease;\n  cursor: help;\n  pointer-events: stroke;\n}\n\n/* Low Temperature Line - Faded for hierarchy */\n.forecast__low-path {\n  stroke: rgba(255, 255, 255, 0.4);\n  stroke-width: 2;\n  fill: none;\n  transition: stroke-width 0.2s ease;\n  cursor: help;\n  pointer-events: stroke;\n}\n\n/* Visual feedback when hovering */\n.forecast__high-path:hover {\n  stroke-width: 4; /* Gets thicker to show it's active */\n}\n\n.forecast__low-path:hover {\n  stroke-width: 4;\n  stroke: rgba(255, 255, 255, 0.8);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
